import {Routes, Route, Link} from 'react-router-dom';

export default function WorksHeader(props){

    return (
        <div className="row" id="worksHeader">
            <div className="col-12 col-lg-7 name">
                <div className="row">
                    <section className="wrapper">
                        <Link to={"/"}><div className="top">KURZWEIL</div></Link>
                    </section>
                </div>
            </div>
            <div className="col-12 col-lg-5 nav">
                <div className="row">
                    <div className="col-4">
                        <Link to={"/all-works"}><span>WORKS</span></Link>
                    </div>
                    <div className="col-4">
                        <Link to={"/booking"}><span>BOOKING</span></Link>
                    </div>
                    <div className="col-4">
                        <Link to={"/contact"}><span>CONTACT</span></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}